module.exports = __webpack_public_path__ + "img/118.066260fc.png";